import * as React from "react";
import { NO_LAYOUT_PATHS } from "./src/components/layout/layoutConfig";
import Layout from "./src/components/layout";
import "./src/styles/index.scss";
import { ThemeProvider } from "./src/contexts/ThemeContext";

export const onRouteUpdate = ({ location }) => {
  const measurementId = process.env.GATSBY_GA_MEASUREMENT_ID;
  if (measurementId && typeof window.gtag === "function") {
    window.gtag("config", measurementId, {
      page_path: location.pathname,
    });
  }
};

export const wrapPageElement = ({ element, props }) => {
  const path = props?.location?.pathname;
  const layout = NO_LAYOUT_PATHS.has(path)
    ? "none"
    : props?.pageContext?.layout || "default";
  return (
    <ThemeProvider>
      <Layout layout={layout}>{element}</Layout>
    </ThemeProvider>
  );
};
